import { RouteType } from './config'
import NewsanIcons from '../components/common/Icons'
import Integrators from '../pages/integrators/Integrators'
import StoresCatalogacion from '../pages/stores-catalogacion/StoresCatalogacion'
import Categories from '../pages/categories/Categories'
import Attributes from '../pages/attributes/Attributes'
import Brands from '../pages/brands/Brands'
import AttributesValues from '../pages/attributes-values/AttributesValues'
import TransactionsReport from '../pages/transactions-report/TransactionsReport'

const appRoutes: RouteType[] = [  
    {
      path: 'integradores',
      element: <Integrators />,
      state: 'integradores',
      sidebarProps: {
        displayText: 'Integradores',
        icon: NewsanIcons.STOCK
      },
      roles: ['admin', 'catalogador']
      },
      {
      path: 'tiendas',
      element: <StoresCatalogacion />,
      state: 'tiendas.catalogacion',
      sidebarProps: {
        displayText: 'Tiendas',
        icon: NewsanIcons.STORE
      },
      roles: ['admin', 'catalogador']
      },
      {
      path: 'transactions',
      element: <TransactionsReport></TransactionsReport>,
      state: 'transactions',
      sidebarProps: {
        displayText: 'Transacciones',
        icon: NewsanIcons.ANALYSIS
      },
      roles: ['admin', 'catalogador']
      },
      {
      path: 'tiendas/categorias/:id',
      element: <Categories />,
      state: 'tiendas.catalogacion.categorias',
      roles: ['admin', 'catalogador']
      },
      {
      path: 'tiendas/categorias/:id/atributos/:relationsCategoryId',
      element: <Attributes />,
      state: 'tiendas.catalogacion.categorias.atributos',
      roles: ['admin', 'catalogador']
      },
      {
      path: 'tiendas/marcas/:id',
      element: <Brands />,
      state: 'tiendas.catalogacion.marcas',
      roles: ['admin', 'catalogador']
      },
      {
      path: 'atributos/:attributeStoreId/:idAttributeRelation/atributo-valores',
      element: <AttributesValues />,
      state: 'atributo-valores',
      roles: ['admin', 'catalogador']
      },
  ]


export default appRoutes
